import { readString2nvggcfaijfhd as readString } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readText(_this__u8e3s4) {
  return readString(_this__u8e3s4);
}
//region block: exports
export {
  readText as readText3frapgncbqrcg,
};
//endregion

//# sourceMappingURL=Deprecation.mjs.map
